module.exports = __webpack_public_path__ + "img/device-status-not-activated.0a7aafa3.svg";